import { FunctionComponent, ReactNode } from 'react';

import { m as motion } from 'framer-motion';
import styled from 'styled-components';

import { WarningIcon } from 'chime-ui/components/Icons';
import { colors, values } from 'chime-ui/system';

type InlineErrorMessageProps = {
  children?: ReactNode;
};

const InlineErrorMessage: FunctionComponent<InlineErrorMessageProps> = ({
  children,
}) => (
  <SlideDownAnimation
    initial={{ scaleY: 0 }}
    animate={{ scaleY: 1 }}
    exit={{ scaleY: 0 }}
    transition={{ type: 'easeIn', delay: values.TIMEOUT_DELAY }}
  >
    <MessageText>
      <WarningIcon />
      {children}
    </MessageText>
  </SlideDownAnimation>
);

const SlideDownAnimation = styled(motion.div)`
  transform-origin: 50% 0;
`;

const MessageText = styled.p`
  display: flex;
  align-items: baseline;
  margin: 0;
  height: auto;
  box-sizing: border-box;
  padding: 0.5rem 0;
  font-weight: 300;
  line-height: 1rem;
  background: none;
  color: ${colors.alertRed};
  border-radius: 0;
  font-size: 0.75rem;
  margin: 0 0;
  box-sizing: border-box;
`;

export default InlineErrorMessage;
